import { render, staticRenderFns } from "./TileProductSample.vue?vue&type=template&id=195b5af1"
import script from "./TileProductSample.vue?vue&type=script&lang=js"
export * from "./TileProductSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports